import { afterNextRender, Directive, ElementRef, input } from '@angular/core';
import { SwiperOptions } from 'swiper/types';
import { SwiperContainer } from 'swiper/element/bundle';

@Directive({
    standalone: true,
    selector: '[appSwiper]'
})
export class SwiperDirective {
    config = input<SwiperOptions>();

    constructor(private el: ElementRef<SwiperContainer>) {
        afterNextRender(() => {
            Object.assign(this.el.nativeElement, this.config());
            this.el?.nativeElement?.initialize();
        });
    }
}
